export default function GlobalExceptionPage() {
  return (
    <div className="flex justify-center items-center h-screen bg-cover bg-center relative">
      {/* Overlay with content */}
      <div className="bg-white rounded-lg shadow-lg p-12 transform hover:scale-105 transition-transform duration-300">
        <div className="text-center">
          <h1 className="text-3xl font-semibold text-red-600">
            Access Denied
          </h1>
          <p className="font-semibold text-gray-700">
            Sorry, you don't have access to this page.
          </p>
          <a href="/" className="text-white font-bold bg-orange-500 mt-7 block py-2 px-4 rounded hover:bg-orange-600">
            Go Back to Login Page
          </a>
        </div>
      </div>
    </div>
  );
}
